module.exports = __webpack_public_path__ + "media/educators/nacac_full_logo-4c5d82a4.svg";